import React from 'react';
import { ClusterNameFieldContainer } from '@domain/dashboard/cluster/campaign-table-cluster-components/components/cluster-name-edit-field/cluster-name-field.container';
import { isUntagged } from '@domain/dashboard/cluster/campaign-table-cluster-components/campaign-table-cluster.utils';
import { UntaggedClusterName } from './cluster-name-wrapper.styles';

export const ClusterNameWrapper = (props: any) => {
    const { cluster_name: clusterName } = props?.row?.values;

    if (isUntagged(clusterName)) {
        return (
            <UntaggedClusterName>
                {clusterName}
            </UntaggedClusterName>
        );
    }

    return <ClusterNameFieldContainer {...props} />;
};
